import React from 'react';
import clsx from 'clsx';
import formStyles from '../../../../components/form/form.module.scss';
import { Input } from '../../../../components/uikit/inputs/Input.tsx';
import { MenuItem, Select } from '@mui/material';
import { Button } from '../../../../components/uikit/buttons/Button.tsx';
import { NegativeActionText } from '../../../../components/uikit/NegativeActionText.tsx';
import { FilterProps } from '../SNLots.tsx';
import { useScopedTranslation } from '../../../../application/localization/useScopedTranslation.ts';
import ArrowDown from 'assets/icons/arrow-down-selector.svg?react';
import styles from '../SNLots.module.scss';
import { IconButton } from '../../../../components/uikit/IconButton.tsx';
import Cross from 'assets/icons/close-button-small.svg?react';
import { tDynamic } from '../../../../helpers/tDynamic.ts';

export const Filters = (props: FilterProps) => {
  const {
    form,
    selectState,
    periodOptions,
    isResetButtonShow,
    resetFilters,
    changeSelectionState,
    validFromAmountOfPeriods,
    number,
    validFromPeriodType,
    typeOfSerialNumber,
    typeOptions,
  } = props;

  const i18n = useScopedTranslation('Page.SNLots');

  return (
    <form onSubmit={form.handleSubmitDefault}>
      <div className={clsx(formStyles.rowContainer, styles.filterContainer)}>
        <div
          className={clsx(
            formStyles.rowContainer,
            styles.alignItemsUnset,
            styles.columnGap8,
            styles.marginTopMinus3,
          )}
        >
          <div className={styles.greyText}>{i18n.t('type')}</div>
          <Select
            data-test-id={'type-select'}
            open={selectState.typeOfSerialNumber}
            onClick={() => {
              changeSelectionState({ typeOfSerialNumber: true });
            }}
            onClose={(e) => {
              e.stopPropagation();
              changeSelectionState({ typeOfSerialNumber: false });
            }}
            value={typeOfSerialNumber}
            onChange={(e) =>
              form.setValue('typeOfSerialNumber', e.target.value)
            }
            className={clsx(formStyles.select, styles.width142)}
            IconComponent={ArrowDown}
            MenuProps={{
              PaperProps: {
                className: clsx(formStyles.selectBody, styles.width142),
              },
              disableScrollLock: true,
            }}
          >
            {typeOptions.map((typeOption) => (
              <MenuItem key={typeOption} value={typeOption}>
                {tDynamic(i18n, typeOption)}
              </MenuItem>
            ))}
          </Select>
        </div>
        <Input
          testId={'number-input'}
          className={clsx(styles.width142)}
          leftHelperText={i18n.t('number')}
          {...form.register('number')}
          type={'number'}
          endAdornment={
            <div>
              {number && (
                <IconButton
                  type={'destroy'}
                  onClick={() => form.setValue('number', null)}
                >
                  <Cross />
                </IconButton>
              )}
            </div>
          }
          endAdornmentClassname={styles.endAdornmentClassname}
        />
        <div
          className={clsx(
            formStyles.rowContainer,
            styles.alignItemsUnset,
            styles.columnGap8,
          )}
        >
          <Input
            testId={'time-interval-input'}
            className={clsx(styles.width84)}
            leftHelperText={i18n.t('valid_from_last')}
            {...form.register('validFromAmountOfPeriods')}
            type={'number'}
            endAdornment={
              <div>
                {validFromAmountOfPeriods && (
                  <IconButton
                    type={'destroy'}
                    onClick={() =>
                      form.setValue('validFromAmountOfPeriods', null)
                    }
                  >
                    <Cross />
                  </IconButton>
                )}
              </div>
            }
            endAdornmentClassname={styles.endAdornmentClassname}
          />
          <Select
            open={selectState.validFromLast}
            onClick={() => {
              changeSelectionState({ validFromLast: true });
            }}
            onClose={(e) => {
              e.stopPropagation();
              changeSelectionState({ validFromLast: false });
            }}
            value={validFromPeriodType}
            onChange={(e) =>
              form.setValue('validFromPeriodType', e.target.value)
            }
            className={clsx(formStyles.select, styles.width120)}
            IconComponent={ArrowDown}
            MenuProps={{
              PaperProps: {
                className: clsx(formStyles.selectBody, styles.width120),
              },
              disableScrollLock: true,
            }}
          >
            {periodOptions.map((periodOption) => (
              <MenuItem key={periodOption} value={periodOption}>
                {tDynamic(i18n, periodOption)}
              </MenuItem>
            ))}
          </Select>
        </div>
        <Button
          testId={'filters-apply-button'}
          type={'submit'}
          className={clsx(formStyles.actionButton)}
          title={i18n.t('apply')}
        />
        {isResetButtonShow && (
          <NegativeActionText
            testId={'filters-reset-button'}
            text={i18n.t('reset')}
            onClickHandler={resetFilters}
          />
        )}
      </div>
    </form>
  );
};
